module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.posts) ? _c('div', {
    staticClass: "panel thread"
  }, [_c('breadcrumbs', {
    attrs: {
      "breadcrumbs": [{
          title: 'Forum',
          link: '/forum'
        },
        {
          title: _vm.forum,
          link: '/discussion/' + _vm.forumId
        },
        {
          title: _vm.topic,
          link: '/discussion/' + _vm.forumId + '/' + _vm.topicId
        } ]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.topic))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.posts), function(post, $index) {
    return _c('div', [(post.topLevel === true) ? _c('discussion-post', {
      attrs: {
        "answerData": _vm.answer,
        "threadCreator": _vm.createdBy,
        "postData": post,
        "topic": _vm.topicId,
        "title": _vm.topic,
        "tags": _vm.tags,
        "postCategories": _vm.categories
      }
    }) : _c('discussion-post', {
      attrs: {
        "threadCreator": _vm.createdBy,
        "postData": post,
        "topic": _vm.topicId,
        "title": _vm.topic
      }
    })], 1)
  })), _vm._v(" "), (_vm.totalPages > 1) ? _c('ul', {
    staticClass: "forum-pagination"
  }, [_c('li', [_c('a', {
    staticClass: "previous-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("«")])]), _vm._v(" "), _vm._l((_vm.totalPages), function(i) {
    return _c('li', [_c('a', {
      class: {
        'current-page': i === (_vm.currentPage + 1)
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentPage = (i - 1)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(i) + "\n                    ")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "previous-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("»")])])], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "col-xs-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postReply(_vm.topicId)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "post-reply"
    }
  }, [_c('vue-html5-editor', {
    ref: "replyForm",
    attrs: {
      "content": _vm.reply,
      "height": 300
    },
    on: {
      "change": _vm.updateContent
    }
  })], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.lightboxImages) ? _c('div', {
    staticClass: "lightbox",
    on: {
      "keyup": function($event) {
        _vm.closeLightbox()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        _vm.lightboxImages = null
      }
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "lightbox",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.lightboxImages), function(slide) {
    return _c('swiper-slide', {
      on: {
        "click": function($event) {
          _vm.lightboxImages = null
        }
      }
    }, [_c('img', {
      attrs: {
        "src": slide
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f47c298!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thread.vue
// module id = 1984
// module chunks = 2